// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

	jQ('.search-button').on('click', function() {
		setTimeout(function() {
			jQ('.boost-pfs-search-suggestion-wrapper, .boost-pfs-search-suggestion-mobile-overlay, .boost-pfs-search-suggestion-mobile-top-panel').remove();
			boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
		}, 500);
	});

	InstantSearch.prototype.beforeInit = function () {
    jQ('#search-results').attr("style", "display: none !important");
    if(Utils.isCollectionPage()) {
      jQ('.collection-filtering-section').hide();
    }
  };
  
  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;

    jQ('.site-nav--mobile .search-button').off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ('.search-input-group input[type="search"]').focus();
      self.openSuggestionMobile();
      jQ('.drawer__close > button').trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;

    jQ('.site-header__links .search-button').off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ('#SearchContainer #search-input').focus();
      self.openSuggestionStyle3();
      jQ('.drawer__close > button').trigger('click');

    });
  }
  
  /**
   * @description Add a capture "onEnter" event handler to prevent the default behavior of the Flow theme
   */
  SearchInput.prototype.afterBindEvents = function () {
    if (this.$element && this.$element[0]) {
      const keydownHandler = function (event) {
        if (event.key == 'Enter') {
          event.stopImmediatePropagation();
          event.stopPropagation();
          event.preventDefault();
          Globals.currentTerm = Utils.stripHtml(this.$element.val());
          if (!Globals.currentTerm && event && event.target) {
            Globals.searchTerm = Utils.stripHtml(event.target.value);
          }

          var query = Utils.unescape(Globals.currentTerm);
          query = query.trim().replace(/\s+/g, ' ');
          window.location.href = `/search?q=${encodeURIComponent(query)}`;
        }
      }

      this.$element[0].addEventListener("keydown", keydownHandler.bind(this), true)
    }
  }

})();
